<div class="toast {{ data.type }}">
  {{ data.text }}<ng-container *ngIf="data.type === 'success'"> 👍</ng-container>
  <a href="javascript:;" class="close" (click)="close()"><i class="icon-close"></i></a>
</div>
